import { getCurrentUser, fetchUserAttributes, signOut } from 'aws-amplify/auth';

export const getCurrentUserRights = async () => {
	try {
		const user = await getCurrentUser();
		// With Amplify v6, we need to use fetchAuthSession instead of accessing signInUserSession directly
		const { accessToken, idToken } = await import('aws-amplify/auth').then(module => 
			module.fetchAuthSession()
		).then(session => session.tokens || {});
		
		// Extract groups from the token payload
		const groups = idToken?.payload["cognito:groups"] || [];
		if (groups.length > 0) {
			window.localStorage.setItem("userRights", groups[0].toString().toLowerCase());
			return groups[0].toString().toLowerCase();
		}
		return null;
	} catch (err) {
		console.log(err);
		return null;
	}
}

export const getCurrentUserId = async () => {
	try {
		// In Amplify v6, we need to use fetchUserAttributes to get user attributes
		const attributes = await fetchUserAttributes();
		const id = attributes.sub;
		if (id) {
			// Store user ID in localStorage for easy access across the app
			window.localStorage.setItem("userId", id.toString().toLowerCase());
			
			 // We DON'T want to set the currentDoctorId to the user's ID
			 // The currentDoctorId should be set only when the user selects a doctor from the list
			
			return id.toString().toLowerCase();
		}
		return null;
	} catch (err) {
		console.log(err);
		return null;
	}
}

export const logout = async () => {
    try {
        await signOut();
        window.localStorage.clear();
        window.location.href = '/'; // Force a page reload to ensure the authentication state is reset
    } catch (err) {
        console.error("Error signing out:", err);
    }
};